import PBKDF2 from 'crypto-js/pbkdf2';
import SHA256 from 'crypto-js/sha256';
import WordArray from 'crypto-js/lib-typedarrays';
import Hex from 'crypto-js/enc-hex';
import type { CodeChallengeConfig } from './auth.contracts';

export function generateCodeChallenge(): CodeChallengeConfig {
	const salt = WordArray.random(16);
	const key128Bits = PBKDF2('M42 Allow AuthWithPkce', salt, { keySize: 128 / 32 });
	const code_verifier = key128Bits.toString(Hex);

	const code_challenge_hash = SHA256(code_verifier);
	const code_challenge = code_challenge_hash.toString(Hex);

	return {
		code_verifier: code_verifier,
		code_challenge: code_challenge,
		code_challenge_method: 's256',
	};
}

export function checkCodeChallenge(codeVerifier: string, codeChallenge: string) {
	const code_challenge_hash = SHA256(codeVerifier);
	const code_challenge = code_challenge_hash.toString(Hex);
	return codeChallenge === code_challenge;
}
